<script setup lang="ts">
import { usePermissionsDialogStore } from '#auth/composables/usePermissionsDialogStore'
import { Button } from '@forgd/ui-kit/button'
import { Dialog, DialogContent } from '@forgd/ui-kit/dialog'
import { ExclamationCircleIcon } from '@heroicons/vue/24/outline'

const auth = useAuth()
const permissionsDialogStore = usePermissionsDialogStore()
const forbiddenModal = computed(() => permissionsDialogStore.forbiddenModal)
</script>

<template>
  <Dialog :open="forbiddenModal.isOpen" @update:open="(open) => !open && permissionsDialogStore.closeForbiddenModal()">
    <DialogContent>
      <div class="space-y-5 font-display">
        <div class="space-y-[0.625rem]">
          <component
            :is="forbiddenModal.icon ?? ExclamationCircleIcon"
            class="size-7.5 text-primary-300"
            aria-hidden="true"
          />
          <h1 class="text-xl font-semibold text-primal">
            {{ forbiddenModal.header ?? `You don't have access to perform this action` }}
          </h1>
          <p class="text-gray-600 text-sm">
            <component
              :is="forbiddenModal.description"
              v-if="forbiddenModal.description && typeof forbiddenModal.description !== 'string'"
            />
            <template v-else>
              {{
                forbiddenModal.description
                  ?? `This action is reserved for admins in ${auth.project?.ticker}'s token space. Please reach out to an admin if you need assistance.`
              }}
            </template>
          </p>
        </div>
        <div class="flex gap-4">
          <Button variant="outline" class="flex-1" @click="permissionsDialogStore.closeForbiddenModal">
            Got It
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>
